import { Typography } from "@mui/material";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";
import WhatsAppButton from "../../../Components/CluppForms/WhatsappButton";

const OtherInsuranceQuotation = ({ state, setState }) => {
  return (
    <>
      <TitleHeaders title={"¡Queremos ayudarte a obtener la mejor oferta!"} />
      <Typography variant="body1">
        Nos gustaría tener la oportunidad de mejorar esa oferta para que puedas
        seguir con nosotros.
        <span role="img" aria-label="thinking face">
          🤔
        </span>
      </Typography>
      <Typography variant="body1">
        Por favor, envíanos la cotización del otro seguro y haremos nuestro
        mejor esfuerzo para ofrecerte una mejor oferta.
      </Typography>
      <br />
      <Typography variant="body1" gutterBottom>
        Puedes enviarnos la cotización por WhatsApp haciendo clic en el botón de
        abajo.
      </Typography>
      <WhatsAppButton
        title={"Enviar cotización"}
        link={
          "https://wa.me/5215577460177?text=Hola,%20env%C3%ADo%20la%20cotizaci%C3%B3n%20del%20otro%20seguro%20para%20mejorar%20la%20oferta"
        }
      />
    </>
  );
};

export default OtherInsuranceQuotation;
